const config = {
    id: 5,
    name: "留白",
    type: 1,
    module_code: "split_line",
    icon: "icon-tms-split_line",
    font_icon: "&#xe602;",
    style_type: 1,
    link_type: 0,
    height: 10,
    color: "#FFFFFF"
};

export default config;